export const FEED_REPORT_REASONS = [
  { label: "Harcèlement ou intimidation", value: "harassment" },
  { label: "Propos haineux ou discriminatoires", value: "hate" },
  { label: "Violence, menaces ou contenu choquant", value: "inappropriate" },
  { label: "Terrorisme ou extrémisme violent", value: "inappropriate" },
  { label: "Nudité ou contenu sexuel", value: "inappropriate" },
  { label: "Exploitation ou mise en danger d’un mineur", value: "inappropriate" },
  { label: "Suicide, automutilation ou comportements dangereux", value: "inappropriate" },
  { label: "Arnaque, fraude ou lien malveillant", value: "spam" },
  { label: "Spam ou manipulation de la plateforme", value: "spam" },
  { label: "Usurpation d’identité ou compte trompeur", value: "other" },
  { label: "Atteinte à la vie privée", value: "inappropriate" },
  { label: "Information fausse ou contenu manipulé", value: "misinformation" },
  { label: "Vente ou promotion de produits et services interdits", value: "other" },
  { label: "Atteinte à mes droits de propriété intellectuelle", value: "other" },
  { label: "Autre problème", value: "other" },
];